import BaseService from '@/services/base_service';
import { clearPhone } from '@/services/string';
import Axios from 'axios';

export default class PolicyService extends BaseService {

   async get(id) {
      try {
         return await axios.get('/apolice/' + id);
      } catch (e) {
         throw e;
      }
   }
   async list(params) {
      try {
         return await axios.get('/apolice', params);
      } catch (e) {
         throw e;
      }
   }

   async listPoliciesClient(params) {
      try {
         return await axios.get('/apolice/apoliceCliente/', params);
      } catch (e) {
         throw e;
      }
   }

}



// WEBPACK FOOTER //
// ./src/services/policy.js